export default __webpack_public_path__ + "static/EPS_328x212-d998f20d8e68a7c76156d1dcb275232e.jpeg";